import { Injectable, inject } from '@angular/core';
import { StorageService } from '@core/services/storages.service';
import { Request } from '@core/models/requests.model';
import { SellsHistory } from '@core/interfaces/catalogos.intefaces';

@Injectable({
  providedIn: 'root',
})
export class SellsHistoryService {
  private url = `ventas/historial/ventas/search`;
  private readonly storageService = inject(StorageService);
  private readonly request = inject(Request);

  getDemosHistory(idProspecto: string) {
    const body = {
      configuracion: this.request.getConfigUser(),
      idProspecto: idProspecto,
    };
    const options = {
      headers: this.request.headers,
    };
    return this.request.Post<SellsHistory>(`${this.url}`, body, options);
  }
}
